import {createSelector} from 'reselect';
import {getAllPaymentOptions} from "../invoice/Selectors";

export const getChecksSelector = createSelector([getAllPaymentOptions], (payment_cards) => {
  return payment_cards.filter(_ => _.payment_card_type === 'EC');
});
export const getCreditCardsSelector = createSelector([getAllPaymentOptions ], (payment_cards, sessionCards) => {
  return payment_cards.filter(_ => _.payment_card_type !== 'EC');
});
